"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e,i,o,l,n,t,r,d=require("../node_modules/graphql-tag/lib/index.js");exports.ConfigurationState=void 0,(e=exports.ConfigurationState||(exports.ConfigurationState={})).New="NEW",e.Saved="SAVED",e.Submitted="SUBMITTED",exports.ConfiguratorOptionType=void 0,(i=exports.ConfiguratorOptionType||(exports.ConfiguratorOptionType={})).Appliance="appliance",i.Material="material",i.Structural="structural",exports.ConfiguratorValueType=void 0,(exports.ConfiguratorValueType||(exports.ConfiguratorValueType={})).Upgrade="upgrade",exports.FeatureType=void 0,(o=exports.FeatureType||(exports.FeatureType={})).Details="Details",o.Featurette="Featurette",o.Included="Included",o.MarketingFeatures="MarketingFeatures",o.Materials="Materials",exports.ImageType=void 0,(l=exports.ImageType||(exports.ImageType={})).Floorplan="Floorplan",l.Thumbnail="Thumbnail",exports.NodeType=void 0,(n=exports.NodeType||(exports.NodeType={})).Brand="Brand",n.ConfiguratorOption="ConfiguratorOption",n.ConfiguratorValue="ConfiguratorValue",n.Feature="Feature",n.Image="Image",n.Model="Model",n.None="None",n.Retailer="Retailer",n.Testimonial="Testimonial",exports.ReferenceType=void 0,(t=exports.ReferenceType||(exports.ReferenceType={})).Brand="Brand",t.Feature="Feature",t.Model="Model",exports.SortOrder=void 0,(r=exports.SortOrder||(exports.SortOrder={})).Asc="ASC",r.Desc="DESC",d.gql`
    query getModelService($slug: String, $salesModelId: Int, $zipcode: String, $includeDimensions: Boolean!, $includePrice: Boolean!, $includeFloorplan: Boolean!, $includeThumbnail: Boolean!, $includeDollhouse: Boolean!, $includeMatterport: Boolean!, $includeGallery: Boolean!, $includeTestimonials: Boolean!, $includeFeatures: Boolean!) {
  model(slug: $slug, salesModelId: $salesModelId, zipCode: $zipcode) {
    id
    salesModelId
    sourceId
    modelNumber
    description
    slug
    name
    beds @include(if: $includeDimensions)
    baths @include(if: $includeDimensions)
    squareFeet @include(if: $includeDimensions)
    length @include(if: $includeDimensions)
    width @include(if: $includeDimensions)
    price @include(if: $includePrice)
    floorplan @include(if: $includeFloorplan) {
      url
      description
    }
    thumbnail @include(if: $includeThumbnail) {
      url
      description
    }
    dollhouse @include(if: $includeDollhouse) {
      url
      description
    }
    matterport @include(if: $includeMatterport)
    multiSection
    zipCode
    galleryImages @include(if: $includeGallery) {
      url
      description
    }
    testimonials @include(if: $includeTestimonials) {
      edges {
        node {
          name
          content
        }
      }
    }
    contentfulFeatures @include(if: $includeFeatures) {
      edges {
        node {
          name
          ordinal
          type
          description
          featureTag
          thumbnail
          icon
        }
      }
    }
  }
}
    `,d.gql`
    query getModelsService($sortBy: SortBy, $zipcode: String, $filters: ModelFilters, $locationFilters: LocationFilters, $includeDimensions: Boolean!, $includePrice: Boolean!, $includeFloorplan: Boolean!, $includeThumbnail: Boolean!, $includeDollhouse: Boolean!, $includeMatterport: Boolean!, $includeGallery: Boolean!, $includeTestimonials: Boolean!, $includeFeatures: Boolean!) {
  models(
    sortBy: $sortBy
    zipCode: $zipcode
    filters: $filters
    locationFilters: $locationFilters
  ) {
    edges {
      node {
        id
        salesModelId
        sourceId
        modelNumber
        description
        slug
        name
        beds @include(if: $includeDimensions)
        baths @include(if: $includeDimensions)
        squareFeet @include(if: $includeDimensions)
        length @include(if: $includeDimensions)
        width @include(if: $includeDimensions)
        price @include(if: $includePrice)
        floorplan @include(if: $includeFloorplan) {
          url
          description
        }
        thumbnail @include(if: $includeThumbnail) {
          url
          description
        }
        dollhouse @include(if: $includeDollhouse) {
          url
          description
        }
        matterport @include(if: $includeMatterport)
        multiSection
        zipCode
        galleryImages @include(if: $includeGallery) {
          url
          description
        }
        testimonials @include(if: $includeTestimonials) {
          edges {
            node {
              name
              content
            }
          }
        }
        contentfulFeatures @include(if: $includeFeatures) {
          edges {
            node {
              name
              ordinal
              type
              description
              featureTag
              thumbnail
              icon
            }
          }
        }
      }
    }
  }
}
    `;
//# sourceMappingURL=generated-types.js.map
